<template>
  <div v-if="data.open" class="info-block">
    <div v-if="false" class="alert alert-warning alert_message shadow">
      <p><strong>Рекомендации для проекта ЛШ!</strong></p>
      <template v-if="data.client && data.client.blackList">
        <p>Добрый день!</p>
        <p>Да, смотрю, этот препарат есть в наличии на складе, последняя упаковка. Но вижу что он отложен для клиента,
          до завтрашнего утра.</p>
        <p>Так что к сожалению - не смогу принять заявку на него. Мне очень жаль.</p>
      </template>
      <template>
        <p>Если клиент спрашивает про чек или сертификат, то говорим:</p>
        <p>Да, конечно, есть и чек, и сертификат, все по закону.</p>
        <p>Сейчас разговариваю с Вами, и смотрю по компьютеру - вижу препарат есть в наличии на складе, последняя
          упаковка. Но вижу что он отложен для клиента, до завтрашнего утра.</p>
        <p>Так что к сожалению - не смогу принять заявку на него. Мне очень жаль.</p>
      </template>
    </div>
    <div class="card">
      <div class="card-body">
        <button
          @click="data.open = false"
          type="button"
          class="btn btn-default btn-xs btn-close"
        >
          Закрыть
        </button>
        <div class="flex">
          <div class="client_block">
            <div class="avatar">
              <img src="/assets/img/avatars/gomer.jpg" alt="">
            </div>
            <div>
              <p>Имя: <strong>{{ data.client.name }}</strong></p>
              <p v-if="data.client.registered" class="text-muted fs-12">Регистрация: {{
                  printDate(data.client.registered)
                }}</p>
            </div>
          </div>
          <div class="flex--grow">
            <p>Входящий номер: <strong>{{ data.phoneNum }}</strong>
              <button @click="copyToBuffer(data.phoneNum)"
                      class="btn btn-outline-info btn-xs"
                      type="button"
              ><i class="icon-fa icon-fa-copy"></i></button>
            </p>
            <div v-if="data.client.blackList">
              <p class="badge badge-danger">Номер в черном списке</p>
              <p class="text-muted fs-12">
                {{ data.client.blackList.comments[(data.client.blackList.comments.length - 1)].text }}</p>
            </div>
            <p>Звонит на: <strong>{{ data.toPhoneNum }} <span class="fs-18 badge badge-info">{{
                data.title
              }}</span></strong>
            </p>
            <p v-if="data.client.last_order">Заявка:
              <button
                class="btn btn-info btn-xs"
                type="button"
                @click="loadOrder(data.client.last_order.id)"
              >
                {{ data.client.last_order.id }}
              </button>
              {{ $AllProjects[data.client.last_order.site_id].title }}
              {{ $AllCities[data.client.last_order.city_id].short_name }} <span
                class="badge badge-dark">{{ data.client.last_order.status_label }}</span>
            </p>
            <div class="text-right flex">
              <!--              <button @click="openClientRequest" class="btn btn-info btn-xs mr-2">Сохранить запрос клиента</button>-->
              <button @click="createOrder" class="btn btn-success btn-xs">Создать заявку с текущим клиентом</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {fillOrderBus} from "@/eventsBus";

export default {
  props: ['data'],
  computed: {
    $AllProjects() {
      const projects = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return projects;
    },
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  methods: {
    openClientRequest() {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          data: {
            client: this.data.client,
            call: {
              phone_num: this.data.phoneNum,
              phone_id: this.data.phone_id,
              user_id: this.data.user_id,
              to_phone_id: this.data.to_phone_id
            },
          },
          drawer: {small: true},
          type: 'ClientIncomeRequest',
        },
        // callBackAction: 'closeOrderModal'
      })
    },
    loadOrder(id) {
      this.data.open = false
      this.mixinGoToRouter("editOrder", {id: id});
    },
    createOrder() {
      console.log(this.$route.name);
      const data = {
        client: this.data.client,
        phoneNum: this.data.phoneNum,
        phoneCallId: this.data.phone_call_id,
        extra_data: {
          city_id: this.data.city_id,
          project_id: this.data.project_id,
          mirror_id: this.data.mirror_id,
        }
      };
      console.log(data);
      if (this.$route.name === 'newOrder') {
        fillOrderBus.$emit(
          'updateFillOrder',
          data
        );
      } else {
        this.mixinGoToRouter("newOrder", data);
      }
    },
    copyToBuffer(id) {
      const el = document.createElement('textarea');
      el.value = id;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      // const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
  }
}
</script>

<style scoped>
.info-block {
}

.avatar img {
  max-width: 40px;
  margin-right: 10px;
}

.card {
  margin-bottom: 5px;
  position: relative;
}

.card-body {
  padding-top: 22px;
}

.btn.btn-close {
  position: absolute;
  right: 5px;
  top: 3px;
  padding: 1px 10px !important;
  background-color: #ededed;
}

.fs-12 {
  font-size: 12px;
}

.fs-18 {
  font-size: 18px;
}

.info-block .card {
  background-color: #f7f6f6;
  -webkit-box-shadow: 2px 2px 15px -5px #000000;
  box-shadow: 2px 2px 15px -5px #000000;
}

.alert_message {
  position: absolute;
  z-index: 99999;
  left: -600px;
  width: 600px;
}

.alert_message p {
  margin-bottom: 3px;
}

.flex--grow {
  flex-grow: 1;
}

.client_block {
  width: 35%;
  padding-right: 10px;
}

.card p {
  margin-bottom: 2px;
}
</style>
